import apiClient  from '../utils/apiClient';

const TIME_OFF_TYPES_TTL_MS = 5 * 60 * 1000;
let cachedTypes = null;
let cachedTypesAt = 0;
let inFlightTypes = null;

export const invalidateTimeOffTypes = () => {
  cachedTypes = null;
  cachedTypesAt = 0;
  inFlightTypes = null;
};

// Time Off Types
export const getTimeOffTypes = async () => {
  if (cachedTypes && Date.now() - cachedTypesAt < TIME_OFF_TYPES_TTL_MS) {
    return cachedTypes;
  }
  if (inFlightTypes) {
    return inFlightTypes;
  }
  inFlightTypes = apiClient
    .get('api/timeoff/types')
    .then((response) => {
      cachedTypes = response.data;
      cachedTypesAt = Date.now();
      return cachedTypes;
    })
    .finally(() => {
      inFlightTypes = null;
    });
  return inFlightTypes;
};

export const createTimeOffType = async (typeData) => {
  const response = await apiClient.post('api/timeoff/types', typeData);
  invalidateTimeOffTypes();
  return response.data;
};

export const updateTimeOffType = async (id, typeData) => {
  const response = await apiClient.put(`api/timeoff/types/${id}`, typeData);
  invalidateTimeOffTypes();
  return response.data;
};

export const deleteTimeOffType = async (id) => {
  const response = await apiClient.delete(`api/timeoff/types/${id}`);
  invalidateTimeOffTypes();
  return response.data;
};

// Time Off Requests
export const getTimeOffRequests = async (params = {}) => {
  const response = await apiClient.get('api/timeoff/requests', { params });
  return response.data;
};

export const createTimeOffRequest = async (requestData) => {
  const response = await apiClient.post('api/timeoff/requests', requestData);
  return response.data;
};

export const updateTimeOffRequest = async (id, updateData) => {
  const response = await apiClient.put(`api/timeoff/requests/${id}`, updateData);
  return response.data;
};

export const cancelTimeOffRequest = async (id) => {
  const response = await apiClient.delete(`api/timeoff/requests/${id}`);
  return response.data;
};
